import i18n from "@/i18n";
/**
 * EmployeeBottomNav — Prompt 18B2-P6 §21 · §22 · §23 · §24.
 *
 * Three primary destinations:
 *   * home       — Home
 *   * shifts     — My shifts
 *   * more       — More (contains Logout / device-reset actions)
 *
 * Fake / dead controls are NOT allowed by §22; the third slot uses
 * `More` because Employee Mobile does not yet expose a real Time Off
 * self-service feature.
 */
import { cn } from "@/lib/utils";

const _items = [
    { key: "home", get label() { return i18n.t("wf.employeeBottomNav.home", "Home"); }, testid: "mobile-nav-home" },
    { key: "shifts", get label() { return i18n.t("wf.employeeBottomNav.myShifts", "My shifts"); }, testid: "mobile-nav-shifts" },
    { key: "more", get label() { return i18n.t("wf.employeeBottomNav.more", "More"); }, testid: "mobile-nav-more" },
];

function _iconFor(key, selected) {
    const stroke = selected ? "#0a0a0a" : "#7a7a7a";
    const common = {
        width: 22,
        height: 22,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke,
        strokeWidth: 1.6,
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };
    if (key === "home") {
        return (
            <svg {...common}>
                <path d="M3 11 12 3l9 8" />
                <path d="M5 10v10h14V10" />
            </svg>
        );
    }
    if (key === "shifts") {
        return (
            <svg {...common}>
                <rect x="3" y="4" width="18" height="17" rx="2" />
                <path d="M3 9h18" />
                <path d="M8 2v4M16 2v4" />
            </svg>
        );
    }
    // more
    return (
        <svg {...common}>
            <circle cx="5" cy="12" r="1.4" />
            <circle cx="12" cy="12" r="1.4" />
            <circle cx="19" cy="12" r="1.4" />
        </svg>
    );
}

export function EmployeeBottomNav({ current, onChange }) {
    return (
        <nav
            data-testid="mobile-bottom-nav"
            aria-label={i18n.t("wf.employeeBottomNav.employeeMobileNavigation", "Employee Mobile navigation")}
            className="fixed bottom-0 inset-x-0 z-40 border-t
                        border-neutral-200/70 bg-[#faf6ef]/95
                        backdrop-blur supports-[backdrop-filter]:bg-[#fbfaf7]/85
                        pb-[env(safe-area-inset-bottom)]"
        >
            <ul className="mx-auto flex max-w-md items-stretch">
                {_items.map((it) => {
                    const selected = current === it.key;
                    return (
                        <li key={it.key} className="flex-1">
                            <button
                                type="button"
                                data-testid={it.testid}
                                aria-current={selected ? "page" : undefined}
                                onClick={() => onChange(it.key)}
                                className={cn(
                                    "flex w-full flex-col items-center gap-1",
                                    "py-2 min-h-[52px]",
                                    "text-[11px] transition-colors",
                                    "active:opacity-70",
                                    selected
                                        ? "text-neutral-900 font-medium"
                                        : "text-neutral-500",
                                )}
                            >
                                {_iconFor(it.key, selected)}
                                <span>{it.label}</span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

export default EmployeeBottomNav;
